import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../config/firebase';
import { collection, getDocs } from 'firebase/firestore';
import Sidebar from './Shared/Sidebar';
import Icon from './Shared/Icons';
import { useAuth } from '../context/AuthContext';
import {
  fetchOfficeTournaments, createOfficeTournament, addRound, updateRound,
  removeRound, declareWinner, reopenTournament, deleteOfficeTournament,
  addParticipant, removeParticipant, assignReferee, updateTotalRounds,
  suggestedRounds, generateSwissRound, computeStandings,
} from '../utils/officeTournament';
import { resolveAuthorName } from '../utils/programData';
import { fmtDate } from '../utils/weekUtils';
import { T } from './Programs/ui';

// ══════════════════════════════════════════════════════════════════════
//  MASHINDANO YA OFISINI — muundo wa premium, ukitumia rangi na herufi
//  zilezile za msingi za App hii (T.green, T.serif, kadi za mviringo).
// ══════════════════════════════════════════════════════════════════════

const RESULTS = [
  { v: '', l: 'Bado' },
  { v: '1-0', l: 'Mweupe' },
  { v: '½-½', l: 'Sare' },
  { v: '0-1', l: 'Mweusi' },
];

const P = {
  page: { display: 'flex', minHeight: '100vh', background: T.bg, fontFamily: T.sans },
  main: { flex: 1, padding: '26px 20px 60px', overflowY: 'auto', width: '100%', maxWidth: '100%' },
  hero: {
    background: `linear-gradient(135deg, #0B3524, #175239)`, color: '#fff',
    borderRadius: '20px', padding: '26px 24px', marginBottom: '18px',
  },
  card: {
    background: '#fff', borderRadius: '16px', padding: '20px',
    border: `1px solid ${T.line}`, marginBottom: '16px',
  },
  h2: { fontFamily: T.serif, fontSize: '18px', color: T.green, margin: '0 0 14px' },
  sub: { fontSize: '13px', color: T.muted, lineHeight: 1.6 },
  label: { display: 'block', fontSize: '12.5px', fontWeight: 700, color: '#374151', marginBottom: '6px' },
  input: {
    width: '100%', padding: '11px 13px', borderRadius: '10px',
    border: `1px solid ${T.line}`, fontSize: '14px', fontFamily: 'inherit',
    background: '#FCFBF8', color: T.ink, boxSizing: 'border-box', outline: 'none',
  },
  btn: {
    background: `linear-gradient(135deg, ${T.green}, ${T.greenLight})`, color: '#fff',
    border: 'none', padding: '13px 20px', borderRadius: '12px', fontSize: '13.5px',
    fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  },
  btnGhost: {
    background: '#fff', color: T.green, border: `1px solid ${T.line}`,
    padding: '11px 16px', borderRadius: '11px', fontSize: '12.5px',
    fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
  },
  pill: {
    display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 11px',
    borderRadius: '99px', fontSize: '11px', fontWeight: 700,
  },
  empty: { textAlign: 'center', padding: '36px 20px', color: T.muted, fontSize: '13px' },
  err: { background: '#FEF2F2', color: '#991B1B', padding: '12px 14px', borderRadius: '10px', fontSize: '13px', marginBottom: '14px' },
  ok: { background: '#ECFDF5', color: '#065F46', padding: '12px 14px', borderRadius: '10px', fontSize: '13px', marginBottom: '14px' },
};

export default function OfficeChess() {
  const { currentUser, userRole } = useAuth();
  const navigate = useNavigate();
  const isAdmin = userRole === 'admin';

  const [tournaments, setTournaments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  async function load() {
    setLoading(true);
    try {
      const ts = await fetchOfficeTournaments();
      setTournaments(ts);
      setOpenId(prev => prev || (ts[0]?.id ?? null));
    } catch (e) { console.error(e); setErr('Imeshindikana kupakia mashindano.'); }
    setLoading(false);
  }

  function flash(m) { setMsg(m); setTimeout(() => setMsg(''), 3500); }

  const active = tournaments.find(t => t.id === openId);
  const isReferee = !!active && active.refereeId === currentUser?.uid;
  const canManage = isAdmin || isReferee;

  return (
    <div style={P.page}>
      <Sidebar />
      <div style={P.main}>

        <div style={P.hero}>
          <div style={{ fontSize: '10.5px', letterSpacing: '2px', opacity: 0.7, fontWeight: 800 }}>
            IYANNA FOUNDATION
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: '12px', marginTop: '9px', flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontFamily: T.serif, fontSize: '26px', lineHeight: 1.15 }}>Mashindano ya Ofisini</div>
              <div style={{ fontSize: '13px', opacity: 0.85, marginTop: '7px' }}>
                Chess ya wafanyakazi kila wiki — mshindi anapatikana Ijumaa
              </div>
            </div>
            {isAdmin && (
              <button
                onClick={() => setShowCreate(!showCreate)}
                style={{
                  background: showCreate ? 'rgba(255,255,255,0.15)' : '#fff',
                  color: showCreate ? '#fff' : T.green,
                  border: 'none', padding: '12px 20px', borderRadius: '12px',
                  fontSize: '13px', fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit',
                  whiteSpace: 'nowrap',
                }}
              >
                {showCreate ? 'Funga' : '+ Mashindano Mapya'}
              </button>
            )}
          </div>
        </div>

        {!isAdmin && (
          <div style={{ ...P.card, background: '#EFF6FF', border: '1px solid #BFDBFE', color: '#1E3A8A', fontSize: '12.5px', lineHeight: 1.7 }}>
            <Icon name="info" size={13} color="#1D4ED8" /> Unaona standings na matokeo kama mtazamaji.
            {isReferee ? ' Umeteuliwa kuwa msimamizi wa mashindano haya — unaweza kupanga raundi na kutangaza mshindi.' : ' Admin ndiye anayeendesha mashindano, au anaweza kumteua msimamizi.'}
          </div>
        )}

        {msg && <div style={P.ok}>{msg}</div>}
        {err && <div style={P.err}>{err}</div>}

        {showCreate && isAdmin && (
          <CreateTournament
            currentUser={currentUser}
            onDone={(id) => { setShowCreate(false); load(); setOpenId(id); flash('Mashindano yametengenezwa.'); }}
            onError={setErr}
          />
        )}

        {loading ? (
          <div style={{ ...P.card, ...P.empty }}>Inapakia...</div>
        ) : tournaments.length === 0 ? (
          <div style={{ ...P.card, ...P.empty }}>
            {isAdmin ? 'Bado hakuna mashindano. Bofya "+ Mashindano Mapya" kuanzisha ya wiki hii.' : 'Bado hakuna mashindano yaliyoanzishwa.'}
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', gap: '7px', marginBottom: '16px', overflowX: 'auto', paddingBottom: '2px' }}>
              {tournaments.map(t => (
                <button key={t.id} onClick={() => setOpenId(t.id)} style={{
                  whiteSpace: 'nowrap', padding: '9px 16px', borderRadius: '99px', cursor: 'pointer',
                  border: `1px solid ${openId === t.id ? T.green : T.line}`,
                  background: openId === t.id ? T.green : '#fff',
                  color: openId === t.id ? '#fff' : T.muted,
                  fontSize: '12.5px', fontWeight: 700, fontFamily: 'inherit',
                }}>
                  {t.title} {t.status === 'completed' ? '🏆' : ''}
                </button>
              ))}
            </div>

            {active && (
              <TournamentDetail
                key={active.id}
                tournament={active}
                isAdmin={isAdmin}
                canManage={canManage}
                onChange={load}
                flash={flash}
                setErr={setErr}
                onOpenPrint={() => navigate(`/office-chess/${active.id}/print`)}
              />
            )}
          </>
        )}

      </div>
    </div>
  );
}

// ══ KUTENGENEZA MASHINDANO MAPYA — majina, si akaunti ══════════════════
function CreateTournament({ currentUser, onDone, onError }) {
  const [title, setTitle] = useState(`Mashindano ya Ofisini — ${fmtDate(new Date())}`);
  const [nameInput, setNameInput] = useState('');
  const [names, setNames] = useState([]);
  const [totalRounds, setTotalRounds] = useState(3);
  const [roundsTouched, setRoundsTouched] = useState(false);
  const [busy, setBusy] = useState(false);

  function addName() {
    const n = nameInput.trim();
    if (!n) { onError('Andika jina kwanza kabla ya kubofya "+ Ongeza".'); return; }
    if (names.some(x => x.toLowerCase() === n.toLowerCase())) { onError('Jina hili tayari limeongezwa.'); return; }
    const next = [...names, n];
    setNames(next);
    setNameInput('');
    onError('');
    if (!roundsTouched) setTotalRounds(suggestedRounds(next.length));
  }
  function removeName(n) {
    const next = names.filter(x => x !== n);
    setNames(next);
    if (!roundsTouched) setTotalRounds(suggestedRounds(next.length));
  }

  async function submit() {
    if (!title.trim()) { onError('Weka jina la mashindano.'); return; }
    if (names.length < 2) { onError('Ongeza angalau wachezaji 2.'); return; }
    setBusy(true); onError('');
    try {
      const authorName = await resolveAuthorName(currentUser);
      const id = await createOfficeTournament({
        title: title.trim(), participantNames: names, totalRounds,
        author: { uid: currentUser.uid, name: authorName },
      });
      onDone(id);
    } catch (e) { console.error(e); onError('Imeshindikana kutengeneza mashindano.'); }
    setBusy(false);
  }

  return (
    <div style={P.card}>
      <h2 style={P.h2}>Mashindano Mapya</h2>
      <label style={P.label}>Jina la mashindano</label>
      <input style={{ ...P.input, marginBottom: '16px' }} value={title} onChange={e => setTitle(e.target.value)} />

      <label style={P.label}>Ongeza wachezaji ({names.length})</label>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
        <input
          style={{ ...P.input, flex: 1 }}
          value={nameInput}
          placeholder="Andika jina la mfanyakazi..."
          onChange={e => setNameInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addName(); } }}
        />
        <button type="button" style={{ ...P.btnGhost, padding: '11px 16px' }} onClick={addName}>+ Ongeza</button>
      </div>

      {names.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px', marginBottom: '9px' }}>
          {names.map(n => (
            <span key={n} style={{
              display: 'inline-flex', alignItems: 'center', gap: '7px',
              background: `${T.green}12`, color: T.green, padding: '6px 11px',
              borderRadius: '99px', fontSize: '12.5px', fontWeight: 700,
            }}>
              {n}
              <span onClick={() => removeName(n)} style={{ cursor: 'pointer', color: '#DC2626', fontWeight: 800 }}>✕</span>
            </span>
          ))}
        </div>
      )}
      <div style={{ fontSize: '11.5px', color: T.muted, marginBottom: '18px' }}>
        Andika jina, bonyeza Enter au "+ Ongeza". Kawaida ni watu 4 hadi 20.
      </div>

      <label style={P.label}>Idadi ya raundi (mfumo wa Swiss)</label>
      <input
        type="number" min={1} max={15}
        style={{ ...P.input, marginBottom: '8px', maxWidth: '140px' }}
        value={totalRounds}
        onChange={e => { setRoundsTouched(true); setTotalRounds(Number(e.target.value) || 1); }}
      />
      <div style={{ fontSize: '11.5px', color: T.muted, marginBottom: '18px' }}>
        Pendekezo kwa wachezaji {names.length || '—'}: raundi {suggestedRounds(names.length)}.
        Unaweza kubadilisha wakati wowote baadaye.
      </div>

      <button style={{ ...P.btn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submit}>
        {busy ? 'Inatengeneza…' : 'Anzisha Mashindano'}
      </button>
    </div>
  );
}

// ══ TAARIFA ZA MASHINDANO ═══════════════════════════════════════════════
function TournamentDetail({ tournament, isAdmin, canManage, onChange, flash, setErr, onOpenPrint }) {
  const [showRound, setShowRound] = useState(false);
  const [pairs, setPairs] = useState([{ whiteId: '', blackId: '', result: '' }]);
  const [byeId, setByeId] = useState('');
  const [editingRound, setEditingRound] = useState(null);
  const [busy, setBusy] = useState(false);
  const [winnerPick, setWinnerPick] = useState('');
  const [showWinner, setShowWinner] = useState(false);
  const [showAddPlayer, setShowAddPlayer] = useState(false);
  const [newPlayer, setNewPlayer] = useState('');
  const [showReferee, setShowReferee] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [refereePick, setRefereePick] = useState('');
  const [showRoundsEdit, setShowRoundsEdit] = useState(false);
  const [roundsInput, setRoundsInput] = useState(tournament.totalRounds || 3);
  const [showRoster, setShowRoster] = useState(false);

  const standings = computeStandings(tournament);
  const rounds = tournament.rounds || [];
  const latestRound = rounds[rounds.length - 1];
  // Wachezaji wa Mashindano ya Ofisini ni majina pekee (hakuna club) —
  // hivyo mpangilio hapa ni A-Z tu, ili wapatikane haraka kwenye dropdown.
  const sortedParticipants = [...tournament.participants].sort((a, b) => a.name.localeCompare(b.name));
  const pendingInLatest = latestRound ? latestRound.pairings.filter(p => !p.result) : [];
  const tournamentDone = tournament.totalRounds > 0
    && rounds.length >= tournament.totalRounds
    && rounds.every(r => r.pairings.every(p => p.result));

  function addPairRow() { setPairs(p => [...p, { whiteId: '', blackId: '', result: '' }]); }
  function removePairRow(i) { setPairs(p => p.filter((_, j) => j !== i)); }
  function changePair(i, k, v) { setPairs(p => p.map((row, j) => j === i ? { ...row, [k]: v } : row)); }

  function resetRoundForm() {
    setPairs([{ whiteId: '', blackId: '', result: '' }]);
    setByeId(''); setShowRound(false); setEditingRound(null);
  }

  function editRound(r) {
    setPairs(r.pairings.map(p => ({ ...p })));
    setByeId(r.byeId || '');
    setEditingRound(r.number);
    setShowRound(true);
  }

  function runAutoPairing() {
    const out = generateSwissRound(tournament);
    if (out.error) { setErr(out.error); return; }
    if (!out.pairings.length) { setErr('Imeshindikana kupanga — kila mtu tayari amecheza na kila mmoja.'); return; }
    setPairs(out.pairings.map(p => ({ ...p })));
    setByeId(out.byeId || '');
    setErr('');
  }

  async function submitRound() {
    const valid = pairs.filter(p => p.whiteId && p.blackId);
    if (!valid.length) { setErr('Ongeza angalau mchezo mmoja wenye wachezaji wote wawili.'); return; }
    if (!editingRound && tournament.totalRounds && rounds.length >= tournament.totalRounds) {
      const ok = window.confirm(
        `Umeshafikisha raundi ${tournament.totalRounds} zilizopangwa. Ongeza raundi ya ziada (${rounds.length + 1}) hata hivyo?`
      );
      if (!ok) return;
    }
    setBusy(true); setErr('');
    try {
      const named = valid.map(p => ({
        ...p,
        whiteName: tournament.participants.find(x => x.id === p.whiteId)?.name || '',
        blackName: tournament.participants.find(x => x.id === p.blackId)?.name || '',
      }));
      const byeName = byeId ? tournament.participants.find(x => x.id === byeId)?.name || '' : '';
      const payload = { pairings: named, byeId: byeId || null, byeName: byeName || null };

      if (editingRound) await updateRound(tournament.id, editingRound, payload);
      else await addRound(tournament.id, payload);

      resetRoundForm();
      flash(editingRound ? 'Raundi imebadilishwa.' : 'Raundi imechapishwa — washiriki wanaweza kuona mechi zao.');
      onChange();
    } catch (e) { console.error(e); setErr('Imeshindikana kuhifadhi raundi.'); }
    setBusy(false);
  }

  async function delRound(num) {
    if (!window.confirm(`Futa Raundi ${num}?`)) return;
    try { await removeRound(tournament.id, num); flash('Raundi imefutwa.'); onChange(); }
    catch (e) { console.error(e); setErr('Imeshindikana kufuta.'); }
  }

  async function confirmWinner() {
    const w = tournament.participants.find(p => p.id === winnerPick);
    if (!w) { setErr('Chagua mshindi.'); return; }
    try {
      await declareWinner(tournament.id, w.id, w.name);
      setShowWinner(false); flash(`${w.name} ametangazwa mshindi! 🏆`); onChange();
    } catch (e) { console.error(e); setErr('Imeshindikana kutangaza mshindi.'); }
  }

  async function undoWinner() {
    if (!window.confirm('Fungua mashindano tena?')) return;
    try { await reopenTournament(tournament.id); flash('Mashindano yamefunguliwa tena.'); onChange(); }
    catch (e) { console.error(e); }
  }

  async function removeTournament() {
    if (!window.confirm(`Futa "${tournament.title}" kabisa? Hatua hii haiwezi kutenduliwa.`)) return;
    try { await deleteOfficeTournament(tournament.id); flash('Mashindano yamefutwa.'); onChange(); }
    catch (e) { console.error(e); setErr('Imeshindikana kufuta.'); }
  }

  async function submitAddPlayer() {
    if (!newPlayer.trim()) { setErr('Andika jina la mchezaji kwanza.'); return; }
    setBusy(true); setErr('');
    try {
      await addParticipant(tournament.id, newPlayer.trim());
      setNewPlayer(''); setShowAddPlayer(false);
      flash('Mchezaji ameongezwa.'); onChange();
    } catch (e) { setErr(e.message || 'Imeshindikana kuongeza mchezaji.'); }
    setBusy(false);
  }

  async function removePlayer(p) {
    if (!window.confirm(`Ondoa ${p.name} kwenye mashindano haya?`)) return;
    try { await removeParticipant(tournament.id, p.id); flash('Mchezaji ameondolewa.'); onChange(); }
    catch (e) { setErr(e.message || 'Imeshindikana kuondoa.'); }
  }

  async function openRefereePicker() {
    setShowReferee(true);
    if (staffList.length) return;
    try {
      const snap = await getDocs(collection(db, 'users'));
      setStaffList(
        snap.docs.map(d => ({ id: d.id, ...d.data() }))
          .filter(u => u.role === 'staff' || u.role === 'admin')
          .map(u => ({ id: u.id, name: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email }))
      );
    } catch (e) { console.error(e); setErr('Imeshindikana kupakia orodha ya staff.'); }
  }

  async function submitReferee() {
    const chosen = staffList.find(s => s.id === refereePick);
    try {
      await assignReferee(tournament.id, chosen?.id || null, chosen?.name || null);
      setShowReferee(false);
      flash(chosen ? `${chosen.name} ameteuliwa kuwa msimamizi.` : 'Msimamizi ameondolewa — admin pekee ndiye anayeendesha.');
      onChange();
    } catch (e) { console.error(e); setErr('Imeshindikana kuteua msimamizi.'); }
  }

  async function submitRoundsEdit() {
    try {
      await updateTotalRounds(tournament.id, roundsInput);
      setShowRoundsEdit(false);
      flash(`Idadi ya raundi imewekwa: ${roundsInput}.`);
      onChange();
    } catch (e) { console.error(e); setErr('Imeshindikana kubadilisha idadi ya raundi.'); }
  }

  const usedThisRound = new Set(pairs.flatMap(p => [p.whiteId, p.blackId]).filter(Boolean));
  const byeCandidates = sortedParticipants.filter(p => !usedThisRound.has(p.id));
  const roundProgress = tournament.totalRounds ? Math.min(100, Math.round((rounds.length / tournament.totalRounds) * 100)) : 0;

  return (
    <>
      {/* Kichwa + maendeleo ya raundi */}
      <div style={{ ...P.card, borderLeft: `4px solid ${tournament.status === 'completed' ? '#B45309' : T.green}` }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
          <div>
            <div style={{ fontFamily: T.serif, fontSize: '19px', color: T.green }}>{tournament.title}</div>
            <div style={{ fontSize: '11.5px', color: T.muted, marginTop: '4px' }}>
              Wachezaji {tournament.participants.length} · Raundi {rounds.length} kati ya {tournament.totalRounds || '—'}
              {tournament.refereeName ? ` · Msimamizi: ${tournament.refereeName}` : ''}
            </div>
          </div>
          {tournament.status === 'completed' ? (
            <span style={{ ...P.pill, color: '#B45309', background: '#FEF3C7' }}>🏆 {tournament.winnerName}</span>
          ) : (
            <span style={{ ...P.pill, color: '#059669', background: '#ECFDF5' }}>Yanaendelea</span>
          )}
        </div>

        {tournament.totalRounds > 0 && (
          <div style={{ height: '8px', background: '#F0EEE7', borderRadius: '99px', marginTop: '15px', overflow: 'hidden' }}>
            <div style={{
              width: `${roundProgress}%`, height: '100%', borderRadius: '99px',
              background: `linear-gradient(90deg, ${T.green}, ${T.greenLight})`, transition: 'width .3s',
            }} />
          </div>
        )}

        {tournamentDone && tournament.status !== 'completed' && (
          <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: '11px', padding: '12px 14px', marginTop: '14px', fontSize: '12.5px', color: '#92400E' }}>
            🏁 Raundi zote {tournament.totalRounds} zimekamilika. Bofya "Tangaza Mshindi" hapa chini.
          </div>
        )}

        <div style={{ display: 'flex', gap: '9px', marginTop: '16px', flexWrap: 'wrap' }}>
          <button style={{ ...P.btnGhost }} onClick={onOpenPrint}>
            📄 Pakua Standings (PDF)
          </button>
          {canManage && tournament.status !== 'completed' && (
            <button style={{ ...P.btnGhost }}
              onClick={() => { setRoundsInput(tournament.totalRounds || 3); setShowRoundsEdit(!showRoundsEdit); }}>
              🔁 Idadi ya Raundi
            </button>
          )}
          {canManage && tournament.status !== 'completed' && (
            <button style={{ ...P.btn, background: '#B45309' }}
              onClick={() => { setWinnerPick(standings[0]?.id || ''); setShowWinner(true); }}>
              Tangaza Mshindi
            </button>
          )}
          {canManage && tournament.status === 'completed' && (
            <button style={{ ...P.btnGhost }} onClick={undoWinner}>Fungua tena</button>
          )}
          {isAdmin && (
            <button style={{ ...P.btnGhost }}
              onClick={() => { setRefereePick(tournament.refereeId || ''); openRefereePicker(); }}>
              👤 {tournament.refereeName ? 'Badilisha Msimamizi' : 'Teua Msimamizi'}
            </button>
          )}
          {isAdmin && (
            <button style={{ ...P.btnGhost, color: '#DC2626' }} onClick={removeTournament}>
              Futa mashindano
            </button>
          )}
        </div>

        {showRoundsEdit && (
          <InlinePanel>
            <label style={P.label}>Idadi ya raundi za mashindano haya</label>
            <input type="number" min={1} max={15} style={{ ...P.input, marginBottom: '11px', maxWidth: '140px' }}
              value={roundsInput} onChange={e => setRoundsInput(Number(e.target.value) || 1)} />
            <PanelActions onSave={submitRoundsEdit} onCancel={() => setShowRoundsEdit(false)} />
          </InlinePanel>
        )}

        {showReferee && (
          <InlinePanel tone="blue">
            <label style={P.label}>Msimamizi wa mashindano haya</label>
            <select style={{ ...P.input, marginBottom: '11px' }} value={refereePick} onChange={e => setRefereePick(e.target.value)}>
              <option value="">— Hakuna, admin pekee anaendesha —</option>
              {staffList.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
            <PanelActions onSave={submitReferee} onCancel={() => setShowReferee(false)} />
          </InlinePanel>
        )}

        {showWinner && (
          <InlinePanel tone="gold">
            <label style={P.label}>Chagua mshindi</label>
            <select style={{ ...P.input, marginBottom: '11px' }} value={winnerPick} onChange={e => setWinnerPick(e.target.value)}>
              {standings.map(s => <option key={s.id} value={s.id}>{s.name} — pointi {s.points}</option>)}
            </select>
            <PanelActions onSave={confirmWinner} onCancel={() => setShowWinner(false)} saveLabel="Thibitisha" saveColor="#B45309" />
          </InlinePanel>
        )}
      </div>

      {/* MECHI ZA SASA — hii ndiyo washiriki wanayoihitaji kuona */}
      {latestRound && (
        <div style={P.card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px' }}>
            <Icon name="flag" size={15} color={T.orange} />
            <h2 style={{ ...P.h2, marginBottom: 0 }}>
              Mechi za Raundi {latestRound.number}
            </h2>
            {pendingInLatest.length > 0 && (
              <span style={{ ...P.pill, color: '#D97706', background: '#FFFBEB' }}>
                {pendingInLatest.length} bado
              </span>
            )}
          </div>

          <div style={{ display: 'grid', gap: '10px' }}>
            {latestRound.pairings.map((p, i) => <MatchCard key={i} p={p} />)}
          </div>

          {latestRound.byeName && (
            <div style={{ fontSize: '12px', color: T.muted, marginTop: '12px' }}>
              💤 Bye raundi hii: <strong>{latestRound.byeName}</strong>
            </div>
          )}
        </div>
      )}

      {/* Standings — leaderboard ya premium */}
      <div style={P.card}>
        <h2 style={P.h2}>Standings</h2>
        {standings.every(s => s.games === 0) ? (
          <div style={P.empty}>Bado hakuna matokeo. {canManage ? 'Panga raundi ya kwanza hapa chini.' : ''}</div>
        ) : (
          <div>
            {standings.map((s, i) => <LeaderRow key={s.id} s={s} rank={i + 1} />)}
          </div>
        )}
      </div>

      {/* Wachezaji */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '11px' }}>
        <h2 style={{ ...P.h2, marginBottom: 0 }}>Wachezaji ({tournament.participants.length})</h2>
        <div style={{ display: 'flex', gap: '7px' }}>
          <button style={{ ...P.btnGhost, padding: '8px 13px' }} onClick={() => setShowRoster(!showRoster)}>
            {showRoster ? 'Funga' : 'Onyesha'}
          </button>
          {canManage && tournament.status !== 'completed' && (
            <button style={{ ...P.btnGhost, padding: '8px 13px' }} onClick={() => setShowAddPlayer(!showAddPlayer)}>
              {showAddPlayer ? 'Funga' : '+ Mchezaji'}
            </button>
          )}
        </div>
      </div>

      {showAddPlayer && (
        <div style={{ ...P.card, display: 'flex', gap: '8px' }}>
          <input
            style={{ ...P.input, flex: 1 }}
            value={newPlayer}
            placeholder="Jina la mchezaji mpya..."
            onChange={e => setNewPlayer(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); submitAddPlayer(); } }}
          />
          <button style={{ ...P.btn, padding: '11px 18px', opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submitAddPlayer}>Ongeza</button>
        </div>
      )}

      {showRoster && (
        <div style={{ ...P.card, display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {sortedParticipants.map(p => (
            <span key={p.id} style={{
              display: 'inline-flex', alignItems: 'center', gap: '7px',
              background: '#FAF8F3', color: T.ink, padding: '7px 12px',
              borderRadius: '99px', fontSize: '12.5px', fontWeight: 600,
              border: `1px solid ${T.line}`,
            }}>
              {p.name}
              {canManage && tournament.status !== 'completed' && (
                <span onClick={() => removePlayer(p)} style={{ cursor: 'pointer', color: '#DC2626', fontWeight: 800 }}>✕</span>
              )}
            </span>
          ))}
        </div>
      )}

      {/* Raundi */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '11px', marginTop: '6px' }}>
        <h2 style={{ ...P.h2, marginBottom: 0 }}>Historia ya Raundi</h2>
        {canManage && tournament.status !== 'completed' && (
          <button style={{ ...P.btn, padding: '9px 16px', fontSize: '12.5px' }}
            onClick={() => (showRound ? resetRoundForm() : setShowRound(true))}>
            {showRound ? 'Funga' : '+ Raundi'}
          </button>
        )}
      </div>

      {showRound && canManage && (
        <div style={P.card}>
          <h2 style={P.h2}>{editingRound ? `Badilisha Raundi ${editingRound}` : `Raundi ${rounds.length + 1}`}</h2>

          {!editingRound && (
            <button
              type="button"
              onClick={runAutoPairing}
              style={{
                display: 'flex', alignItems: 'center', gap: '9px', width: '100%',
                background: `linear-gradient(135deg, ${T.green}, ${T.greenLight})`, color: '#fff',
                border: 'none', padding: '13px 16px', borderRadius: '13px', marginBottom: '18px',
                fontSize: '13.5px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              <Icon name="sparkle" size={16} color="#fff" />
              Panga Kiotomatiki (Swiss)
              <span style={{ marginLeft: 'auto', fontSize: '11px', opacity: 0.85, fontWeight: 600 }}>
                kutokana na standings za sasa
              </span>
            </button>
          )}

          {pairs.map((p, i) => (
            <div key={i} style={{ display: 'flex', gap: '7px', alignItems: 'center', marginBottom: '9px', flexWrap: 'wrap' }}>
              <select style={{ ...P.input, flex: '1 1 140px' }} value={p.whiteId}
                onChange={e => changePair(i, 'whiteId', e.target.value)}>
                <option value="">— Mweupe —</option>
                {sortedParticipants.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
              </select>
              <select style={{ ...P.input, flex: '1 1 140px' }} value={p.blackId}
                onChange={e => changePair(i, 'blackId', e.target.value)}>
                <option value="">— Mweusi —</option>
                {sortedParticipants.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
              </select>
              <select style={{ ...P.input, flex: '0 1 110px' }} value={p.result}
                onChange={e => changePair(i, 'result', e.target.value)}>
                {RESULTS.map(r => <option key={r.v} value={r.v}>{r.l}</option>)}
              </select>
              {pairs.length > 1 && (
                <button onClick={() => removePairRow(i)} style={{ ...P.btnGhost, padding: '9px 11px', fontSize: '11px', color: '#DC2626' }}>✕</button>
              )}
            </div>
          ))}
          <button style={{ ...P.btnGhost, padding: '8px 14px', fontSize: '12px', marginBottom: '16px' }} onClick={addPairRow}>
            + Mchezo mwingine
          </button>

          {byeCandidates.length > 0 && (
            <>
              <label style={P.label}>Bye (hana mpinzani raundi hii)</label>
              <select style={{ ...P.input, marginBottom: '16px' }} value={byeId} onChange={e => setByeId(e.target.value)}>
                <option value="">— Hakuna —</option>
                {byeCandidates.map(x => <option key={x.id} value={x.id}>{x.name}</option>)}
              </select>
            </>
          )}

          <button style={{ ...P.btn, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submitRound}>
            {busy ? 'Inahifadhi…' : editingRound ? 'Hifadhi mabadiliko' : 'Chapisha Raundi'}
          </button>
        </div>
      )}

      {rounds.length === 0 ? (
        <div style={{ ...P.card, ...P.empty }}>Bado hakuna raundi.</div>
      ) : [...rounds].reverse().map(r => (
        <RoundHistory key={r.number} r={r} canManage={canManage} status={tournament.status}
          onEdit={() => editRound(r)} onDelete={() => delRound(r.number)} />
      ))}
    </>
  );
}

// ══ VIPANDE VIDOGO VYA PREMIUM ══════════════════════════════════════════

function MatchCard({ p }) {
  const pending = !p.result;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '10px', padding: '13px 15px',
      background: pending ? '#FAF8F3' : '#fff', border: `1px solid ${pending ? T.line : '#D1FAE5'}`,
      borderRadius: '13px',
    }}>
      <PlayerChip name={p.whiteName} color="#fff" border={T.line} />
      <div style={{ flex: 1, textAlign: 'center' }}>
        <div style={{ fontSize: '13.5px', fontWeight: 800, color: pending ? T.muted : T.green }}>
          {pending ? 'dhidi ya' : p.result}
        </div>
        {pending && <div style={{ fontSize: '10px', color: '#D97706', fontWeight: 700, marginTop: '2px' }}>BADO</div>}
      </div>
      <PlayerChip name={p.blackName} color="#1A1A1A" border="#1A1A1A" textColor="#fff" />
    </div>
  );
}

function PlayerChip({ name, color, border, textColor }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
      <div style={{
        width: '30px', height: '30px', borderRadius: '9px', flexShrink: 0,
        background: color, border: `1.5px solid ${border}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '12px', fontWeight: 800, color: textColor || T.ink,
      }}>
        {(name || '?').charAt(0).toUpperCase()}
      </div>
      <div style={{ fontSize: '13px', fontWeight: 700, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {name}
      </div>
    </div>
  );
}

function LeaderRow({ s, rank }) {
  const medal = rank === 1 ? '🥇' : rank === 2 ? '🥈' : rank === 3 ? '🥉' : null;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 10px',
      borderTop: rank > 1 ? `1px solid #F3F1EB` : 'none',
      background: rank === 1 && s.games > 0 ? '#FFFBEB' : 'transparent',
      borderRadius: rank === 1 ? '11px' : 0,
    }}>
      <div style={{ width: '26px', textAlign: 'center', fontSize: medal ? '16px' : '13px', fontWeight: 800, color: medal ? undefined : T.muted }}>
        {medal || rank}
      </div>
      <div style={{
        width: '34px', height: '34px', borderRadius: '10px', flexShrink: 0,
        background: `${T.green}12`, display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '13px', fontWeight: 800, color: T.green,
      }}>
        {(s.name || '?').charAt(0).toUpperCase()}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '13.5px', fontWeight: 700, color: T.ink }}>{s.name}</div>
        <div style={{ fontSize: '10.5px', color: T.muted, marginTop: '2px' }}>
          W{s.wins} S{s.draws} L{s.losses} · Weupe {s.whiteCount} · Weusi {s.blackCount}
        </div>
      </div>
      <div style={{ fontSize: '18px', fontWeight: 800, color: T.green, fontVariantNumeric: 'tabular-nums' }}>
        {s.points}
      </div>
    </div>
  );
}

function RoundHistory({ r, canManage, status, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);
  const pending = r.pairings.filter(p => !p.result).length;
  return (
    <div style={{ ...P.card, padding: 0, overflow: 'hidden' }}>
      <div onClick={() => setOpen(!open)} style={{
        display: 'flex', alignItems: 'center', gap: '10px', padding: '15px 18px', cursor: 'pointer',
      }}>
        <div style={{ fontSize: '13.5px', fontWeight: 800, color: T.green, flex: 1 }}>
          Raundi {r.number}
        </div>
        {pending > 0 && <span style={{ ...P.pill, color: '#D97706', background: '#FFFBEB' }}>{pending} bado</span>}
        <span style={{ color: T.muted, transform: open ? 'rotate(90deg)' : 'none', transition: '.15s' }}>›</span>
      </div>
      {open && (
        <div style={{ padding: '0 18px 18px' }}>
          <div style={{ display: 'grid', gap: '8px', paddingTop: '4px' }}>
            {r.pairings.map((p, i) => <MatchCard key={i} p={p} />)}
          </div>
          {r.byeName && (
            <div style={{ fontSize: '12px', color: T.muted, marginTop: '10px' }}>💤 Bye: {r.byeName}</div>
          )}
          {canManage && status !== 'completed' && (
            <div style={{ display: 'flex', gap: '6px', marginTop: '13px' }}>
              <button style={{ ...P.btnGhost, padding: '6px 13px', fontSize: '11.5px' }} onClick={onEdit}>Hariri</button>
              <button style={{ ...P.btnGhost, padding: '6px 13px', fontSize: '11.5px', color: '#DC2626' }} onClick={onDelete}>Futa</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function InlinePanel({ children, tone }) {
  const bg = tone === 'blue' ? '#EFF6FF' : tone === 'gold' ? '#FFFBEB' : '#FAF8F3';
  const border = tone === 'blue' ? '#BFDBFE' : tone === 'gold' ? '#FDE68A' : T.line;
  return (
    <div style={{ background: bg, border: `1px solid ${border}`, borderRadius: '13px', padding: '15px', marginTop: '14px' }}>
      {children}
    </div>
  );
}

function PanelActions({ onSave, onCancel, saveLabel = 'Hifadhi', saveColor }) {
  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <button style={{ ...P.btn, padding: '9px 16px', fontSize: '12.5px', ...(saveColor ? { background: saveColor } : {}) }} onClick={onSave}>
        {saveLabel}
      </button>
      <button style={{ ...P.btnGhost, padding: '9px 16px', fontSize: '12.5px' }} onClick={onCancel}>Ghairi</button>
    </div>
  );
}
